import {connect} from 'react-redux';
import Authorize from './Authorize.jsx';

const isAuthorized = (rolesToVerify, userRoles) =>
  rolesToVerify
  .filter(item => !['children'].includes(item) && userRoles.includes(item))
  .length > 0;

const mapStateToProps = (state, props) => ({
  authorized: isAuthorized(Object.keys(props), state.shared.auth.roles)
});

export default connect(mapStateToProps)(Authorize);



// WEBPACK FOOTER //
// ./src/features/shared/auth/AuthorizeContainer.jsx